// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_material_code: yup.string().label("Material code").required(),
  mr_product_material_name: yup.string().label("Material name").required()
})